import React from 'react';

import {
  Box,
  Container,
  styled
} from '@mui/material';
import {
  AppBar,
  BottomAppBar
} from 'modules';



const RootContainerBox = styled(Box)(({ theme }) => ({
  minHeight: `calc(100vh - ${theme.mixins.toolbar.minHeight}px)`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top center'
}));

const ChildContentContainer = styled(Container)(({ theme }) => ({
  marginBottom: theme.mixins.toolbar.minHeight,
  marginTop: theme.spacing(4),
  paddingBottom: theme.spacing(2)
}));



interface IProps {
  imgBackground?: string;
  colorVariant?: 'dark' | 'light';
  backgroundColor?: string;
  backgroundSize?: 'cover' | 'contain';
  doNotWrapChildrenInContainer?: boolean;
  children: React.ReactNode | React.ReactNode[];
}

export const FC: React.FC<IProps> = props => {



  return (
    <RootContainerBox
      sx={{
        backgroundImage: props.imgBackground ? `url('${props.imgBackground}')` : undefined,
        backgroundSize: props.backgroundSize ?? 'cover',
        backgroundColor: props.backgroundColor
      }}>
      <AppBar.FC colorVariant={props.colorVariant} />

      {props.doNotWrapChildrenInContainer ? (
        props.children
      ) : (
        <ChildContentContainer>
          {props.children}
        </ChildContentContainer>
      )}

      <BottomAppBar.FC />
    </RootContainerBox>
  );
};
